export type PhaseRecorder = { ms: Map<string, number>; calls: Map<string, number> };

let active: PhaseRecorder | null = null;

export function beginLoadPhases(): PhaseRecorder {
  active = { ms: new Map(), calls: new Map() };
  return active;
}

export function currentLoadPhases(): PhaseRecorder {
  return active ?? beginLoadPhases();
}

export function recordPhase(name: string, ms: number, recorder: PhaseRecorder | null = active): void {
  if (!recorder) return;
  recorder.ms.set(name, (recorder.ms.get(name) ?? 0) + Math.max(0, ms));
  recorder.calls.set(name, (recorder.calls.get(name) ?? 0) + 1);
}

export function setPhase(name: string, ms: number, recorder: PhaseRecorder | null = active): void {
  if (!recorder) return;
  recorder.ms.set(name, Math.max(0, ms));
  recorder.calls.set(name, 1);
}

export function recordPhaseMax(name: string, ms: number, recorder: PhaseRecorder | null = active): void {
  if (!recorder) return;
  setPhase(name, Math.max(recorder.ms.get(name) ?? 0, ms), recorder);
}

export async function timedPhase<T>(
  name: string,
  work: () => Promise<T>,
  recorder: PhaseRecorder | null = active,
): Promise<T> {
  const started = performance.now();
  try {
    return await work();
  } finally {
    recordPhase(name, performance.now() - started, recorder);
  }
}

export function timedSyncPhase<T>(name: string, work: () => T, recorder: PhaseRecorder | null = active): T {
  const started = performance.now();
  try {
    return work();
  } finally {
    recordPhase(name, performance.now() - started, recorder);
  }
}

export function loadPhases(recorder: PhaseRecorder | null = active): string {
  if (!recorder) return '';
  return [...recorder.ms]
    .map(([name, ms]) => {
      const calls = recorder.calls.get(name) ?? 1;
      return `${name}=${Math.round(ms)}${calls > 1 ? `x${calls}` : ''}`;
    })
    .join(',');
}
